module.exports = __webpack_public_path__ + "img/logo.57fa3d1f.svg";